<app-titolo-subtitolo
  [titolo]="'Sintesi di Sostenibilità'"
  [paddingTop]="10"
  [isArchiviato]="isArchiviato()"
></app-titolo-subtitolo>

<div mat-dialog-content class="dialog-center-cont" style="padding: 0px !important">
  <app-spinner-overlay></app-spinner-overlay>
  <mat-stepper
    [linear]="!isPubblicato() && !isArchiviato()"
    #stepper
    (selectionChange)="cambioStep($event)"
  >
    <mat-step [stepControl]="formCreazioneSostenibilita" [editable]="true">
      <ng-scrollbar [visibility]="'hover'">
        <ng-template matStepLabel> Sintesi di Sostenibilità </ng-template>

        <form
          [formGroup]="formCreazioneSostenibilita"
          [alignItems]="'flex-start'"
          appFormContainer
          [larghezza]="12"
          [gap]="10"
          [rowGap]="5"
          style="align-items: center; padding-right: 20px"
        >
          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">Creazione Sintesi di Sostenibilità</div>

            <div class="descrizione-sezione-dialog">
              Seleziona l'anno e scegli tra l'approccio generico e quello settoriale. Se selezioni
              l'approccio settoriale il sistema elaborerà un framework basato sulle specificità del
              settore di appartenenza. La scelta del sotto-settore aumenterà l'accuratezza
              dell'approccio selezionato
            </div>
          </div>

          <div style="display: flex; flex-direction: column; flex: none; padding-right: 15px">
            <mat-label>Framework</mat-label>
            <mat-radio-group
              class="radio-tipo-sett"
              aria-label="Framework"
              formControlName="tipoSettore"
            >
              <div class="radio-container">
                <mat-radio-button
                  aria-label="Generico"
                  value="GENERALE"
                  [disabled]="
                    this.formCreazioneSostenibilita.get('id')?.value || !this.settoreGenerale
                  "
                >
                  Generale
                </mat-radio-button>
                <div class="eti-check">
                  <mat-icon matTooltip="Adatto ad aziende di ogni settore" class="info-icon">
                    info_outline
                  </mat-icon>
                </div>
              </div>

              <div class="radio-container">
                <mat-radio-button
                  aria-label="Specifico"
                  value="SPECIFICO"
                  [disabled]="
                    this.formCreazioneSostenibilita.get('id')?.value || !this.settoriAzienda.length
                  "
                >
                  Settoriale
                </mat-radio-button>
                @if (
                  !this.formCreazioneSostenibilita.get('id')?.value && !this.settoriAzienda.length
                ) {
                  <div class="eti-check">
                    <mat-icon matTooltip="Estensione settoriale non attiva" class="info-icon">
                      info_outline
                    </mat-icon>
                  </div>
                } @else {
                  <div class="eti-check">
                    <mat-icon
                      matTooltip="Sviluppato ad hoc per il settore di appartenenza dell'azienda"
                      class="info-icon"
                    >
                      info_outline
                    </mat-icon>
                  </div>
                }
              </div>
            </mat-radio-group>
          </div>

          <mat-form-field appFormElement [larghezza]="2">
            <mat-label>Anno</mat-label>
            <mat-select formControlName="anno" placeholder="Anno">
              <mat-option
                *ngFor="let aa of arrayAnni"
                [value]="aa"
                [disabled]="ctrAnnoSintesiUtilizzata(aa)"
                >{{ aa }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="2"
            class="input-form"
            [riempi]="true"
            *ngIf="this.formCreazioneSostenibilita.get('tipoSettore')?.value === 'SPECIFICO'"
          >
            <mat-label>Settore</mat-label>
            <mat-select formControlName="settori" placeholder="Settore" [compareWith]="compareById">
              <mat-option
                *ngFor="let set of settoriAzienda"
                [value]="set"
                [disabled]="ctrSettoreSintesiUtilizzata(set)"
                >{{ set.titolo }}</mat-option
              >
            </mat-select>
          </mat-form-field>

          <mat-form-field
            appFormElement
            [larghezza]="5"
            class="input-form"
            *ngIf="
              this.formCreazioneSostenibilita.get('tipoSettore')?.value === 'SPECIFICO' &&
              arraySottoSettori?.length
            "
          >
            <mat-label>Sotto-settori</mat-label>
            <mat-select
              formControlName="sottoSettori"
              placeholder="Sotto-settori"
              [compareWith]="compareById"
              multiple
            >
              <mat-option *ngFor="let sottoSet of arraySottoSettori" [value]="sottoSet">{{
                sottoSet.titolo
              }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div class="separatore" appFormElement [larghezza]="12">
            <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
          </div>

          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">Informazioni Aziendali</div>

            <div class="descrizione-sezione-dialog">
              Compila le informazioni dimensionali dell'azienda per verificare il regime di
              rendicontazione di sostenibilità da utilizzare.
            </div>
          </div>
          <!--  -->

          <mat-form-field appFormElement [larghezza]="6" [riempi]="true">
            <mat-label>Fatturato</mat-label>
            <input
              matInput
              placeholder="Fatturato"
              formControlName="fatturato"
              type="number"
              appInputNumber
              inputmode="numeric"
              min="0"
              max="999999999999"
              (keydown)="onKeyDown($event)"
            />
            <mat-error appFormError></mat-error>
          </mat-form-field>

          <mat-form-field appFormElement [larghezza]="4" [riempi]="true">
            <mat-label>Nr. Dipendenti</mat-label>
            <input
              matInput
              placeholder="Nr. Dipendenti"
              formControlName="nrDipendenti"
              type="number"
              appInputNumber
              min="0"
              max="999999999999"
              (keydown)="onKeyDownDip($event)"
              inputmode="numeric"
            />
            <mat-error appFormError></mat-error>
          </mat-form-field>

          <div class="separatore" appFormElement [larghezza]="12">
            <app-separatore-label [styleSeparatore]="'small'"></app-separatore-label>
          </div>

          <div appFormElement [larghezza]="12" [riempi]="true">
            <div class="titolo-sezione-dialog">
              Non partire da zero, lega la tua sintesi ad altre attività
            </div>

            <div class="descrizione-sezione-dialog">
              Collegando altri moduli alla sintesi potrai utilizzare le informazioni inserite
              precedentemente. Selezionare l'Analisi di Materialità avrà un impatto sulla scelta
              delle tematiche di sostenibilità da rendicontare.
            </div>
          </div>

          <app-inclusione-moduli
            [annoModulo]="this.formCreazioneSostenibilita.get('anno')?.value"
            [idModulo]="this.formCreazioneSostenibilita.get('id')?.value"
            [settore]="this.formCreazioneSostenibilita.get('settori')?.value"
            [sottoSettore]="this.formCreazioneSostenibilita.get('sottoSettori')?.value"
            [tipoModulo]="'SINTESI'"
            [idModuiliInclusi]="idModuliInclusi"
            [isSoglieSuperate]="isSogliaSuperata()"
          ></app-inclusione-moduli>
        </form>
      </ng-scrollbar>
    </mat-step>

    <!----------------------- SELEZIONE TEMATICHE QUESTIONARIO  ------------------>
    <mat-step [editable]="true" [stepControl]="surveyComp.formCreaCfgQuestionario">
      <ng-template matStepLabel>Tematiche</ng-template>

      <app-cfg-questionario
        #surveyComp
        [isPermessoSoloRead]="isPermessoSoloRead"
        style="padding-right: 20px"
        [tipoQuestionario]="'SINTESI'"
        [cfgQuestionario]="sintesi"
        [idSostenibilita]="formCreazioneSostenibilita.get('id')?.value"
        [nascondiTitolo]="true"
      ></app-cfg-questionario>
    </mat-step>

    <!--  ---------------------- I M P E G N I ---------- -->
    <mat-step>
      <ng-template matStepLabel>Impegni</ng-template>
      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione degli Impegni</div>
          <div class="descrizione-sezione-dialog">
            Gli impegni rappresentano delle dichiarazioni di intento dell’azienda ad operare creando
            impatti positivi e limitando quelli negativi rispetto alle specifiche tematiche di
            sostenibilità.<br />
            Seleziona almeno un impegno aziendale e descrivilo attraverso la compilazione.
            Scegliendo dalla lista proposta troverai linee guida ad hoc per la compilazione.
          </div>
        </div>
      </div>

      <app-selezione-impegni-sintesi
        [isPermessoSoloRead]="isPermessoSoloRead"
        #elemImpegni
        style="padding-right: 20px"
        [objQuestionario]="objQuestionarioImpegni"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneSostenibilita.get('id')?.value"
        [stato]="sintesi?.stato"
        chiaveElementoSelezione="impegno"
        [settore]="sintesi?.settori"
      >
      </app-selezione-impegni-sintesi>
    </mat-step>

    <!--  ---------------------- Azioni e Buone Pratiche  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Azioni e Buone Pratiche </ng-template>
      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione delle Azioni e Buone Pratiche</div>
          <div class="descrizione-sezione-dialog">
            Seleziona le azioni e le buone pratiche che l’azienda mette in atto per le diverse
            tematiche di sostenibilità.<br />
            Attraverso il pulsante <mat-icon>edit</mat-icon> potrai modificare la descrizione delle
            singole azioni selezionate per rappresentare al meglio le iniziative messe in atto
            dall’azienda, oltre a inserire specifiche istruzioni di compilazione per la figura
            designata all’attività attraverso il campo “Note”.
          </div>
        </div>
      </div>

      <app-selezione-azioni-buonepratiche-sintesi
        [isPermessoSoloRead]="isPermessoSoloRead"
        #elemAzioni
        style="padding-right: 20px"
        [objQuestionario]="objQuestionarioAzioniBP"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneSostenibilita.get('id')?.value"
        chiaveElementoSelezione="azionebp"
        [stato]="sintesi?.stato"
        [settore]="sintesi?.settori"
      >
      </app-selezione-azioni-buonepratiche-sintesi>
    </mat-step>
    <!--  ---------------------- K P I ---------- -->
    <mat-step>
      <ng-template matStepLabel> KPI </ng-template>
      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione dei KPI</div>
          <div class="descrizione-sezione-dialog">
            Seleziona gli indicatori di valutazione relativi agli obiettivi di sostenibilità
            stabiliti.
          </div>
        </div>
      </div>

      <div style="display: flex; flex-direction: column; padding-top: 10px">
        <div
          class="titolo-sezione-dialog"
          style="padding-bottom: 5px; display: flex; align-items: center; column-gap: 15px"
        >
          Includi Anni Precedenti
          <mat-slide-toggle
            [disabled]="isPermessoSoloRead"
            labelPosition="before"
            [(ngModel)]="valueToggleAnni"
            [checked]="valueToggleAnni"
            (change)="cambioToggle($event)"
          >
          </mat-slide-toggle>
        </div>
        <div class="descrizione-sezione-dialog">
          <a
            >Abilita la compilazione dei KPI per gli anni precedenti attraverso il bottone a lato e
            attiva le funzionalità connesse all'inserimento dello storico degli indicatori.</a
          >
        </div>
      </div>

      <app-selezione-kpi-sintesi
        [isPermessoSoloRead]="isPermessoSoloRead"
        #elemKpi
        style="padding-right: 20px"
        [objQuestionario]="objQuestionarioKPI"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneSostenibilita.get('id')?.value"
        [stato]="sintesi?.stato"
        chiaveElementoSelezione="kpi"
        [settore]="sintesi?.settori"
      >
      </app-selezione-kpi-sintesi>
    </mat-step>

    <!--  ---------------------- Certificazioni  ---------- -->
    <mat-step>
      <ng-template matStepLabel> Certificazioni </ng-template>
      <div appFormContainer [larghezza]="2" class="cont-titolo-step-selezione">
        <div appFormElement [larghezza]="1" [riempi]="true">
          <div class="titolo-sezione-dialog">Selezione delle Certificazioni</div>
          <div class="descrizione-sezione-dialog">
            Seleziona le certificazioni possedute dall’azienda
          </div>
        </div>
      </div>

      <app-selezione-certificazioni-sintesi
        [isPermessoSoloRead]="isPermessoSoloRead"
        style="padding-right: 20px"
        [objQuestionario]="objQuestionarioCertificazioni"
        chiaveElemento="elementi"
        [idContest]="this.formCreazioneSostenibilita.get('id')?.value"
        [stato]="sintesi?.stato"
        chiaveElementoSelezione="certif"
        [settore]="sintesi?.settori"
      >
      </app-selezione-certificazioni-sintesi>
    </mat-step>

    <!--  ---------------------- C R U S C O T T O ---------- -->
    <mat-step>
      <ng-template matStepLabel>Cruscotto</ng-template>
      <div class="barra-titolo-cruscotto">
        <div style="display: flex; flex-direction: column; flex: 1">
          <div class="titolo-sezione-dialog">Cruscotto Sintesi di Sostenibilità</div>

          <div class="descrizione-sezione-dialog">
            Visualizza e gestisci ogni aspetto relativo alla compilazione: avanzamento,
            configurazione dei testi mail, invio e notifiche.
          </div>
        </div>

        <!-- TOTALI CRUSCOTTO -->
        @if (this.formCreazioneSostenibilita.get('id')?.value) {
          <app-totali-cruscotto
            #totaliCruscotto
            [tipoModulo]="'SINTESI'"
            [idModulo]="this.formCreazioneSostenibilita.get('id')?.value"
          >
          </app-totali-cruscotto>
        }
      </div>
      <ng-scrollbar>
        <div style="padding-right: 20px">
          <app-lista-tabellare
            #tabella
            [defaultPageSize]="4"
            [fnCaricamentoDati]="fnCaricamentoDati"
            [colonne]="colonne"
            [maxNrButton]="1"
            [filtri]="filtri"
            (bottoniListaClick)="bottoniListaClick($event)"
            *ngIf="this.formCreazioneSostenibilita.get('id')?.value"
          >
            <ng-container btnEnd>
              <button
                [disabled]="!isPermessoInvioMail"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="template()"
              >
                <mat-icon matSuffix>settings</mat-icon>
                Config. Testi
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isPermessoSoloRead"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="inviaTutti()"
              >
                <mat-icon matSuffix>mail</mat-icon>
                Invia a Tutti
              </button>

              <button
                [disabled]="!isPermessoInvioMail || isPermessoSoloRead"
                mat-flat-button
                class="primary-button"
                color="primary"
                (click)="notificaTutti()"
              >
                <mat-icon matSuffix>notifications_active</mat-icon>
                Notifica Tutti
              </button>
            </ng-container>
          </app-lista-tabellare>
        </div>
      </ng-scrollbar>
    </mat-step>

    <!--  ---------------------- S T A M P A ---------- -->
    <mat-step>
      <ng-template matStepLabel> Configurazione Stampa </ng-template>

      <app-cfg-stampa
        [isPermessoSoloRead]="isPermessoSoloRead"
        [fnGetConfigStampa]="fnGetConfigStampa"
        style="padding-right: 20px"
        [fnSalvaCfgStampa]="fnSalvaCfgStampa"
        [fnCaricaImg]="fnImportaImmagine"
        [fnEliminaImg]="fnEliminaImg"
        (loading)="toggleLoading($any($event))"
      ></app-cfg-stampa>
    </mat-step>
  </mat-stepper>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button
      mat-flat-button
      color="accent"
      [disabled]="stepper.selectedIndex === 0"
      (click)="indietro()"
      class="accent-button"
    >
      Indietro
    </button>
  </div>
  <ng-container *ngIf="stepper.selectedIndex !== 7">
    <div>
      <button
        mat-flat-button
        color="primary"
        (click)="avantiHTML()"
        class="primary-button"
        #btnAvanti
      >
        Avanti
      </button>
    </div>
    <div *ngIf="mostraBottoneAssegnazioni">
      <button
        mat-flat-button
        color="primary"
        (click)="assegnazioni(stepper.selectedIndex)"
        class="primary-button"
      >
        <mat-icon>person_edit</mat-icon> Assegnazioni
      </button>
    </div>
  </ng-container>
  <ng-container *ngIf="stepper.selectedIndex === 7">
    <button
      *ngIf="!isPermessoSoloRead"
      mat-flat-button
      color="primary"
      (click)="salvaCfgStampa()"
      class="primary-button"
    >
      Salva
    </button>
    <button
      matDialogClose
      *ngIf="isPermessoSoloRead"
      mat-flat-button
      color="accent"
      class="accent-button"
    >
      Chiudi
    </button>
    <button
      [disabled]="!this.cfgStampaComponent.isPermessoStampa"
      mat-flat-button
      color="accent"
      *ngIf="stepper.selectedIndex === 7"
      (click)="stampa()"
      class="accent-button"
      style="margin: 0 !important"
    >
      <mat-icon class="material-icons-outlined"> print </mat-icon>Stampa
    </button>
  </ng-container>
</div>
